import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-remove-article-dialog',
  templateUrl: './remove-article-dialog.component.html',
  styleUrls: ['./remove-article-dialog.component.scss']
})
export class RemoveArticleDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<RemoveArticleDialogComponent>,

    @Inject(MAT_DIALOG_DATA) public data: {
      id: string,
      title: string,
      code: string
    },
  ) {}

  onConfirm(id: string) {
    this.dialogRef.close({ id: id });
  }
}
